import DoDisturbIcon from '@mui/icons-material/DoDisturb';
import EditIcon from '@mui/icons-material/Edit';
import LoopOutlinedIcon from '@mui/icons-material/LoopOutlined';
import { openDialogDispositivi } from "../../redux/reducers/dialogDispositivo-reducer";
import { useDispatch } from "react-redux";
import { GridActionsCellItem } from "@mui/x-data-grid";
import Tooltip from '@mui/material/Tooltip';
import { useSelector } from 'react-redux';
import {policies as permessi} from "../../const/policies"

const ButtonBoxDispositivi = ({ rowId, rowInfo }) => {
  const state = useSelector((state) => state.userDate);
  const { policies } = state;
  const dispatch = useDispatch();
  
  const handleDialogToEdit = ({dialogType, rowInfo}) => {
    dispatch(openDialogDispositivi({dialogType, rowInfo}))
  };

  return (
    <>
      {policies.indexOf(permessi.dispositiviInserimentoModifica) != -1 && <GridActionsCellItem
        icon={
          <Tooltip title="Modifica" >
            <EditIcon color="primary" />
          </Tooltip>
        }
        label="Modifica"
        onClick={() => handleDialogToEdit({dialogType:"edit", rowInfo})}
      />}

      {policies.indexOf(permessi.dispositiviInserimentoModifica) != -1 &&<GridActionsCellItem
        icon={
          <Tooltip title={rowInfo.dispositivoAbilitato ? "Disabilita" : "Abilita"}>
           { rowInfo.dispositivoAbilitato ? <DoDisturbIcon color="primary" /> : <LoopOutlinedIcon color="primary" />}
          </Tooltip> 
        }
        label="Cancella"
        onClick={() => handleDialogToEdit({dialogType:"delete", rowInfo})}
      />}
    </>
  );
};

export default ButtonBoxDispositivi;
